import { ClipboardList, Truck, SlidersHorizontal, Package, Wrench, ScanText } from 'lucide-react'
import type { SectionDefinition } from '@/types'

export const SECTIONS: SectionDefinition[] = [
  {
    id: 'valuation-report',
    icon: <ScanText size={16} strokeWidth={2} />,
    iconColor: '#1e40af',
    name: 'Scan Valuation Reports',
    fields: [],
  },
  {
    id: 'basic-information',
    icon: <ClipboardList size={16} strokeWidth={2} />,
    iconColor: '#1e40af',
    name: 'Basic Information',
    fields: [

      // Claim Information
      { id: 'claimRefNo', label: 'Claim Reference #', type: 'text', placeholder: 'Enter Claim Ref No', required: true, subHeader: 'Claim Information' },
      {
        id: 'typeOfLoss', label: 'Type of Loss', type: 'select', placeholder: 'Select Type of Loss', required: true,
        options: ['Select']
        // options: ['Select','Catastrophe', 'Collision', 'Fire', 'Flood', 'Hail', 'Other', 'Vandalism', 'Comprehensive', 'Property Damage', 'Recovered Theft', 'Unrecovered Theft'],
      },
      { id: 'dateOfLoss', label: 'Date of Loss', type: 'date', placeholder: 'Enter Date of Loss', required: true },
      { id: 'dateClaimReceived', label: 'Date Claim Received', type: 'date', placeholder: 'Date Claim Received', required: true },

      // Owner Information
      { id: 'ownerId', label: 'Owner', type: 'text', placeholder: 'Enter Owner Name', required: true, subHeader: 'Owner Information' },
      { id: 'insured', label: 'Insured', type: 'text', placeholder: 'Enter Insurance Company', required: false },
      // {
      //   id: 'year', label: 'Manufacture Year', type: 'select', required: true,
      //   options: ['Select Year', ...Array.from({ length: 20 }, (_, i) => String(2025 - i))],
      // },
      // { id: 'insuredPhoneNumber', label: 'Insured Phone #', type: 'text', placeholder: 'Enter Phone Number' },
      // { id: 'contactName', label: 'Contact Name', type: 'text', placeholder: 'Enter Contact Name', required: false },
      { id: 'contactCity', label: 'Contact City', type: 'text', placeholder: 'Enter Contact City', required: false },
      {
        id: 'contactState', label: 'Contact State', type: 'select', placeholder: 'Select Contact State', required: false,
        options: ['Select']
      },
      { id: 'valuationZipCode', label: 'Valuation ZIP Code', type: 'text', placeholder: 'Enter Valuation Zip Code', required: true },

      // Appraiser Information
      // { id: 'company', label: 'Company', type: 'text', placeholder: 'Enter Company Name', required: false, subHeader: 'Appraiser Information' },
      // { id: 'c_name', label: 'Name', type: 'text', placeholder: 'Enter Name', required: false },
      // { id: 'c_email', label: 'Email', type: 'text', placeholder: 'Enter Email', required: false },
      // { id: 'c_phone', label: 'Phone', type: 'text', placeholder: 'Enter Phone', required: false },
      // { id: 'c_appraisalAmount', label: 'Appraisal Amount', type: 'text', placeholder: 'Enter Appraisal Amount', required: false },
      // { id: 'c_acvAmount', label: 'ACV Amount', type: 'text', placeholder: 'Enter ACV Amount', required: false },

      // Vehicle Details
      {
        id: 'vehicleType', label: 'Vehicle Type', type: 'select', required: true, subHeader: 'Vehicle Details',
        // options: ['Select','Truck/Tractor', 'Trailer']
        options: ['Select']
      },
    ],
  },
  {
    id: 'standard-equipment',
    icon: <Truck size={16} strokeWidth={2} />,
    iconColor: '#1e40af',
    name: 'Standard Equipment',
    fields: []
  },
  {
    id: 'additional-options',
    icon: <SlidersHorizontal size={16} strokeWidth={2} />,
    iconColor: '#1e40af',
    name: 'Additional Options',
    fields: []
  },

  {
    id: 'body-information',
    icon: <Package size={16} strokeWidth={2} />,
    iconColor: '#1e40af',
    name: 'Body Information',
    fields: []
  },

  {
    id: 'vehicle-condition',
    icon: <Wrench size={16} strokeWidth={2} />,
    iconColor: '#1e40af',
    name: 'Vehicle Condition',
    fields: []
  }
]
